import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#201e31', // Dark navy from Figma
      light: '#3d4057',
      dark: '#1a1b2e',
    },
    secondary: {
      main: '#48eca2', // Bright green from Figma
      light: '#6cefb3',
      dark: '#36d88f',
    },
    background: {
      default: '#f0f0f0', // Light gray background from Figma
      paper: '#ffffff',
    },
    text: {
      primary: '#201e31',
      secondary: '#76748a', // Gray text from Figma
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      color: '#201e31',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 700,
      color: '#201e31',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      color: '#201e31',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 4,
          padding: '10px 24px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(72, 236, 162, 0.3)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          borderRadius: 8,
        },
      },
    },
  },
})

export default theme
